// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__he-QK","alertIcon":"ConfirmModal_alertIcon__3D-Uc"};